import React, { useState, useEffect } from "react"
import { chatService } from "../services/apichat"

const ConversationList = ({ onUserSelect, selectedUserId,adminId }) => {
  const [conversations, setConversations] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState("")

  useEffect(() => {
    console.log("🔄 ConversationList component mounted/updated")
    fetchConversations()
  }, [])

  const fetchConversations = async () => {
    try {
      setLoading(true)
      console.log("Fetching admin conversations...")
      const response = await chatService.getConversations()
      console.log("Conversations response:", response)

      // Handle new API response structure: { success, status, message, data }
      if (response.success && response.data && response.data.conversations) {
        console.log(
          "✅ Conversations found:",
          response.data.conversations.length
        )
        setConversations(response.data.conversations)
      } else if (response.success && response.data === null) {
        console.log("ℹ️ No conversations found yet")
        setConversations([])
      } else {
        console.log("❌ Unexpected conversations response:", response)
        setConversations([])
      }
    } catch (error) {
      console.error("Error fetching conversations:", error)
      setError("Failed to load conversations")
    } finally {
      setLoading(false)
    }
  }

  const formatTime = dateString => {
    const date = new Date(dateString)
    const now = new Date()
    const diffInHours = (now.getTime() - date.getTime()) / (1000 * 60 * 60)

    if (diffInHours < 24) {
      return date.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" })
    } else {
      return date.toLocaleDateString()
    }
  }

  const getUnreadCount = (conversation, currentUserId) => {
    console.log("adminId-------",adminId)
    console.log("conversation-------",conversation)
    const unreadData = conversation.unreadCount.find(
      item => item.userId === adminId
    )
    console.log("unreadData",unreadData)
    return unreadData ? unreadData.count : 0
  }

  const getOtherParticipant = conversation => {
    // For admin, get the user (non-admin participant)
    return conversation.participants.find(p => p.role === "user")
  }
const readUnreadCount=(id)=>{
let dataArr=[...conversations]
dataArr.forEach(item=>{
 if(item?.id===id){
  if(item.unreadCount[0].userId===adminId){
    item.unreadCount[0].count=0
  }
  if(item.unreadCount[1].userId===adminId){
   item.unreadCount[1].count=0
  }
 }
})
setConversations(dataArr)
}
  if (loading) {
    return (
      <div className="loading text-white">
        <div className="spinner"></div>
        <span style={{ marginLeft: "10px" }}>Loading conversations...</span>
      </div>
    )
  }

  if (error) {
    return (
      <div style={{ padding: "20px", textAlign: "center", color: "#dc3545" }}>
        {error}
        <button
          onClick={fetchConversations}
          className="btn btn-primary"
          style={{ marginTop: "10px", padding: "5px 10px", fontSize: "12px" }}
        >
          Retry
        </button>
      </div>
    )
  }

  return (
    <div style={{ flex: 1, overflow: "auto" }}>
      {conversations.length === 0 ? (
        <div style={{ padding: "20px", textAlign: "center", color: "white" }}>
          <p>No conversations yet</p>
          <p style={{ fontSize: "12px", marginTop: "5px",color:"gray" }}>
            Start chatting with users to see conversations here
          </p>
        </div>
      ) : (
        <div>
          {conversations.map(conversation => {
            const otherUser = getOtherParticipant(conversation)
            if (!otherUser) return null

            const unreadCount = getUnreadCount(conversation, "admin") 
            console.log("unreadCount",unreadCount)
            // Assuming current user is admin

            return (
              <div
                key={conversation._id}
                onClick={() => {
                  onUserSelect(otherUser._id)
                  readUnreadCount(conversation._id)
                }}
                style={{
                  padding: "18px 20px",
                  // borderBottom: "0.7px solid #4A5567",
                  cursor: "pointer",
                  background:
                    selectedUserId === otherUser._id ? "#131a30" : "#212C43",
                  transition: "background-color 0.2s ease",
                  position: "relative"
                }}
                onMouseEnter={e => {
                  if (selectedUserId !== otherUser._id) {
                    e.currentTarget.style.backgroundColor = "#131a30"
                  }
                }}
                onMouseLeave={e => {
                  if (selectedUserId !== otherUser._id) {
                    e.currentTarget.style.backgroundColor = "#212C43"
                  }
                }}
              >
                <div style={{ display: "flex", alignItems: "center" }}>
                  <div
                    style={{
                      width: "45px",
                      height: "45px",
                      borderRadius: "50%",
                      background: otherUser.isOnline ? "#28a745" : "#6c757d",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      color: "white",
                      fontWeight: "bold",
                      marginRight: "12px",
                      fontSize: "16px"
                    }}
                  >
                    {otherUser.name.charAt(0).toUpperCase()}
                  </div>

                  <div style={{ flex: 1, minWidth: 0 }}>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center"
                      }}
                    >
                      <h4
                        style={{
                          margin: 0,
                          fontSize: "17px",
                          color: "white",
                          fontWeight: "600",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                          textTransform:"capitalize"
                        }}
                      >
                        {otherUser.name}
                      </h4>

                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "8px"
                        }}
                      >
                        {conversation.lastMessageAt && (
                          <span
                            style={{
                              fontSize: "11px",
                              color: "white",
                              whiteSpace: "nowrap"
                            }}
                          >
                            {formatTime(conversation.lastMessageAt)}
                          </span>
                        )}

                        {unreadCount > 0 && (
                          <div
                            style={{
                              background: "#007bff",
                              color: "white",
                              borderRadius: "50%",
                              width: "18px",
                              height: "18px",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              fontSize: "10px",
                              fontWeight: "bold"
                            }}
                          >
                            {unreadCount > 9 ? "9+" : unreadCount}
                          </div>
                        )}
                      </div>
                    </div>

                    <p
                      style={{
                        margin: "2px 0 0 0",
                        fontSize: "13px",
                        color: "white",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        // whiteSpace: "nowrap"
                      }}
                    >
                      {conversation.lastMessage || "No messages yet"}
                    </p>

                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        marginTop: "4px"
                      }}
                    >
                      <div
                        style={{
                          width: "8px",
                          height: "8px",
                          borderRadius: "50%",
                          background: otherUser.isOnline
                            ? "#28a745"
                            : "#6c757d",
                          marginRight: "6px"
                        }}
                      ></div>
                      <span
                        style={{
                          fontSize: "11px",
                          color: otherUser.isOnline ? "#28a745" : "#6c757d",
                          fontWeight: "500"
                        }}
                      >
                        {otherUser.isOnline ? "Online" : "Offline"}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            )
          })}
        </div>
      )}
    </div>
  )
}

export default ConversationList
